import React from 'react'
import CellValue from 'components/CellValue'
import {getValueByPath} from 'utils/utils'
import environment from 'utils/enums/environment'
import {fieldtype} from 'utils/enums/fieldtype'

export default ({column, row, value, onUpdate}) => {
    const min = column.type === fieldtype.datetime && column.config.mindate ? getValueByPath(row, column.config.mindate) : null
    const max = column.type === fieldtype.datetime && column.config.maxdate ? getValueByPath(row, column.config.maxdate) : null

    const handleChangeValue = (val, col) => {
        onUpdate(row.id, col, val)
    }

    return <CellValue
        row={row ? row.id : null}
        config={column.config}
        type={column.type}
        defaultValue={value}
        foreignerEcn={column.foreignerEcn}
        lookupType={column.lookupType}
        lookupConfig={column.lookupConfig}
        linkedRelation={row ? row['c' + column.linkedRelation] : null}
        name={column.name}
        title={column.title}
        handleUpdateValue={handleChangeValue}
        readonly={column.readonly || column.connection}
        environment={environment.Collection}
        min={min}
        max={max}
    />
}
